// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"SearchInput_wrapperComponent__ewPUX","form":"SearchInput_form__9K0dX","searchButton":"SearchInput_searchButton__fA5oN","input":"SearchInput_input__Z7dn9"};